import type { Middleware } from "redux";

import * as actionTypes from "@/redux/actions/actionTypes";
import { clearFlagInterval, loadTargetedFlags } from "@/redux/actions/featureFlag";
import { getUsernameFromToken } from "@/utils/authToken";

export const featureFlagMiddleware: Middleware = (store) => (next) => (action) => {
  // store.dispatch is typed as Dispatch<AnyAction> but these actions are thunks
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const dispatch: (action: any) => any = store.dispatch;

  if (action.type === actionTypes.LOG_OUT) {
    dispatch(clearFlagInterval());
  }

  const result = next(action);

  if (action.type === actionTypes.AUTH_SUCCESS || action.type === actionTypes.LOAD_TOKEN) {
    // Reducer has already written the new token to localStorage by this point
    const username = getUsernameFromToken();

    if (username) dispatch(loadTargetedFlags());
  }

  return result;
};
